import Big from "big.js";
import { isValidValue } from "../common";
const calcTaxAmount = (unTaxAmount, taxRate, digits = 2) => {
  if (!isValidValue(unTaxAmount) || !isValidValue(taxRate)) {
    return 0;
  }
  try {
    const bigUnTaxAmount = new Big(unTaxAmount);
    const bigTaxRate = new Big(taxRate);
    if (bigTaxRate.lt(0)) {
      console.warn("Tax rate cannot be negative.");
      return 0;
    }
    if (bigUnTaxAmount.lt(0)) {
      console.warn("Un-tax amount cannot be negative.");
      return 0;
    }
    const bigTaxRateRatio = bigTaxRate.lt(1) ? bigTaxRate : bigTaxRate.div(100);
    const multiplier = new Big(1).plus(bigTaxRateRatio);
    const taxAmount = bigUnTaxAmount.times(multiplier);
    return taxAmount.round(digits, Big.roundHalfUp).toNumber();
  } catch (error) {
    console.error("Error calculating taxed amount:", error);
    return 0;
  }
};
const calcUnTaxAmount = (taxAmount, taxRate, digits = 2) => {
  if (!isValidValue(taxAmount) || !isValidValue(taxRate)) {
    return 0;
  }
  try {
    const bigTaxAmount = new Big(taxAmount);
    const bigTaxRate = new Big(taxRate);
    if (bigTaxRate.lt(0)) {
      console.warn("Tax rate cannot be negative.");
      return 0;
    }
    if (bigTaxAmount.lt(0)) {
      console.warn("Tax amount cannot be negative.");
      return 0;
    }
    const bigTaxRateRatio = bigTaxRate.lt(1) ? bigTaxRate : bigTaxRate.div(100);
    const divisor = new Big(1).plus(bigTaxRateRatio);
    const unTaxAmount = bigTaxAmount.div(divisor);
    return unTaxAmount.round(digits, Big.roundHalfUp).toNumber();
  } catch (error) {
    console.error("Error calculating untaxed amount:", error);
    return 0;
  }
};
const formatAmount = (amount, digits = 2) => {
  if (!isValidValue(amount)) {
    return "-";
  }
  try {
    const bigAmount = new Big(amount);
    return bigAmount.round(digits, Big.roundHalfUp).toFixed(digits);
  } catch (error) {
    console.error("Error formatting amount:", error);
    return "-";
  }
};
export {
  calcTaxAmount,
  calcUnTaxAmount,
  formatAmount
};
